
    <mat-tab-group dynamicHeight [(selectedIndex)]="labService.associatedTab">

      <mat-tab label="Parent" *ngIf="tabVisible('parent')">
        <app-parent></app-parent>
      </mat-tab>

      <mat-tab label="HST" *ngIf="tabVisible('hst')">
        <app-hst></app-hst>
      </mat-tab>

      <mat-tab label="SOA" *ngIf="tabVisible('soa')">
        <app-soa></app-soa>
      </mat-tab>

      <mat-tab label="Shared" *ngIf="tabVisible('sharedAssociated')">
        <app-sharedAssociated></app-sharedAssociated>
      </mat-tab>

      <mat-tab label="Multiple" *ngIf="tabVisible('multiple')">
        <app-multiple></app-multiple>
      </mat-tab>

    </mat-tab-group>

